import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import { stringAvatar } from '@components/UserAvatar/helpers';

const UserAvatarInitials = ({
  name,
  onClick,
  sx = {},
}: {
  name: string;
  onClick?: () => void;
  sx?: any;
}) => {
  const avatarProps = stringAvatar((name || '').toUpperCase());

  return (
    <Avatar
      onClick={onClick}
      children={avatarProps.children || <PersonIcon />}
      sx={{ ...sx, ...avatarProps.sx }}
    />
  );
};

export default UserAvatarInitials;
